import React, {createContext, useState} from 'react';

// Contexto para exibir popups/modais simples
export const PopupContext = createContext();

export function PopupProvider({children}) {
    const [popup, setPopup] = useState(null);

    const showPopup = (content) => {
        setPopup(content);
    };

    const hidePopup = () => {
        setPopup(null);
    };

    return (
        <PopupContext.Provider value={{popup, showPopup, hidePopup}}>
            {children}
            {/* Aqui você pode renderizar um Modal/Drawer genérico, por exemplo:
          {popup && <MyModal onClose={hidePopup}>{popup}</MyModal>}
      */}
        </PopupContext.Provider>
    );
}
